var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissionsShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8020_8777)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8020_8777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8020_8777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8020_8777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9463 9.19797C15.9434 7.39914 14.6675 5.8552 12.9009 5.51389C11.1372 5.17112 9.3765 6.1262 8.70121 7.79319C8.02591 9.46018 8.6265 11.3718 10.1324 12.3532C10.1631 12.3708 10.1836 12.4031 10.1836 12.4397C10.1836 12.4748 10.1646 12.5085 10.1324 12.5261C9.03812 12.9245 8.08011 13.6291 7.37552 14.5564C6.5933 15.5891 6.17142 16.8489 6.17582 18.1438C6.17582 18.3708 6.36039 18.5554 6.58744 18.5554C6.81449 18.5554 6.99906 18.3708 6.99906 18.1438C6.99173 15.2961 9.29154 12.9787 12.1407 12.9656H12.2183C14.2764 12.9319 15.9287 11.259 15.9375 9.2009L15.9463 9.19797ZM12.1905 12.1438C10.7915 12.1526 9.58158 11.1697 9.30179 9.79856C9.02201 8.42746 9.7515 7.04905 11.0435 6.50998C12.334 5.97092 13.8267 6.41916 14.6075 7.58079C15.3868 8.74241 15.2359 10.2937 14.2471 11.2839C13.7022 11.8332 12.9624 12.1423 12.1905 12.1438ZM17.4917 15.4602H17.1094V14.5725C17.1372 14.0744 16.8868 13.6013 16.459 13.3435C16.2492 13.217 16.0089 13.1501 15.764 13.1501C15.519 13.1501 15.2787 13.217 15.0689 13.3435C14.6411 13.6013 14.3907 14.0744 14.4185 14.5725V15.4602H14.0362C13.8516 15.4602 13.7036 15.6096 13.7036 15.7927V18.2214C13.7036 18.406 13.8531 18.5539 14.0362 18.5539H17.4917C17.6748 18.5539 17.8243 18.4045 17.8243 18.2214V15.7927C17.8243 15.6096 17.6763 15.4602 17.4917 15.4602ZM16.0049 17.174V17.8567C16.0049 17.8713 15.9991 17.886 15.9873 17.8977C15.9771 17.9079 15.9624 17.9153 15.9463 17.9153H15.5933C15.5786 17.9153 15.564 17.9094 15.5523 17.8977C15.542 17.8874 15.5362 17.8728 15.5362 17.8567V17.174C15.315 17.0627 15.1993 16.8137 15.2564 16.5735C15.3135 16.3332 15.5288 16.1633 15.7764 16.1633C16.024 16.1633 16.2393 16.3332 16.2964 16.5735C16.3535 16.8137 16.2378 17.0627 16.0166 17.174H16.0049ZM16.5923 15.4602H14.9488V14.5974C14.9488 14.1433 15.3164 13.7756 15.7705 13.7756C16.2246 13.7756 16.5923 14.1433 16.5923 14.5974V15.4602Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8020_8777",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8020_8777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionsShort);
export default __webpack_public_path__ + "static/media/Permissions-Short.ba8ebbf4dd9205839edc3eead99c2daa.svg";
export { ForwardRef as ReactComponent };